import { h } from 'preact'
import styles from './menu.module.css'

export const Menu = ({ sections = [] }) => {
  const mappedLinks = sections.map((section) => (
    <a href={`#${section.title}`} class="nrk-button">
      {section.menuTitle || section.title}
    </a>
  ))
  return <div class={styles.menuWrapper}>{mappedLinks}</div>
}
